// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".er-type-step-title[data-v-0fb199d8]{font-weight:700;font-size:24px;line-height:34px;text-align:center;margin-bottom:50px}.er-type-step-option[data-v-0fb199d8]{margin-bottom:30px;cursor:pointer}.er-type-step-option-title[data-v-0fb199d8]{font-weight:700;font-size:24px;line-height:34px}.er-type-step-option-title img[data-v-0fb199d8]{margin-left:40px}.er-type-step-option-desc[data-v-0fb199d8]{margin-top:30px;font-size:14px;line-height:20px;max-width:620px}", ""]);
// Exports
module.exports = exports;
